module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chap",
    attrs: {
      "id": "toc"
    }
  }, [_c('p', {
    staticClass: "ctfm"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "tocfm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/spblinesoffire0007#intro"
    }
  }, [_vm._v("Introduction: Making Mud Pies in the Sty")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/spblinesoffire0008#ch01"
    }
  }, [_vm._v("1. The New Warrior Class")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/spblinesoffire0009#ch02"
    }
  }, [_vm._v("2. The Culture of Future Conflict")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/spblinesoffire0010#ch03"
    }
  }, [_vm._v("3. Our Soldiers, Their Cities")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/spblinesoffire0011#ch04"
    }
  }, [_vm._v("4. Spotting the Losers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/spblinesoffire0012#ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Our New Old Enemies")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/spblinesoffire0013#ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. The American Mission")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/spblinesoffire0014#ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. The Human Terrain of Urban Operations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/spblinesoffire0015#ch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. The Plague of Ideas")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/spblinesoffire0016#ch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. When Devils Walk the Earth")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/spblinesoffire0017#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. Stability, America’s Enemy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/spblinesoffire0018#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. The Black Art of Intelligence")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/spblinesoffire0019#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. Hidden Unities")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/spblinesoffire0020#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13. God’s Real Estate")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/spblinesoffire0021#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14. In Praise of Attrition")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/spblinesoffire0022#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15. Atlantis, the Ideological Superpower")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/spblinesoffire0023#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16. The Goddess of the Southern Seas")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/spblinesoffire0024#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17. The Shape of Wars to Come")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/spblinesoffire0025#ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18. The Ultimate Weapon")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/spblinesoffire0026#ch19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19. Occupation 101")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/spblinesoffire0027#ch20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20. Survival Strategy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/spblinesoffire0028#ch21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21. Blood Borders")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/spblinesoffire0031#ch22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22. Why Clausewitz Had It Backward")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/spblinesoffire0032#ch23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23. Return of the Tribes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/spblinesoffire0033#ch24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24. Lessons from Lebanon")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/spblinesoffire0034#ch25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25. The “Eurabia” Myth")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/spblinesoffire0035#ch26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26. Dream Warriors")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/spblinesoffire0036#ch27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27. Learning to Lose")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/spblinesoffire0037#ch28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28. Better than Genocide")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/spblinesoffire0038#ch29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29. 12 Myths of Twenty-First Century War")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/spblinesoffire0039#ch30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30. Dishonest Doctrine")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/spblinesoffire0040#ch31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31. War’s Irrational Motivators")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/spblinesoffire0041#ch32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32. Fighting Words")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/spblinesoffire0042#ch33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33. Trapping Ourselves in Afghanistan")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/spblinesoffire0043#ch34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34. The Last (Mini) Empire")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/spblinesoffire0044#ch35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35. Charisma and Victory")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0cdf5bff","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/spblinesoffire0006.vue
// module id = 69
// module chunks = 0